import {loading} from '../../common/loading'
import {modifyUserInfoAjax, getUserInfoAjax} from '@/api/baseMsg';
import nativeJSBridge from '@/utils/nativeJSBridge'


export default {
    name: "userInfo",
    data() {
        return {
            righttext: '保存',
            userName: '',
            loginName: '',
            userPosition: '',
            telephone: '',
            email: '',
            address: '',
        }
    },
    created() {
        this.init();
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        },
        onClickRight() {
            // this.$toast('您点击了保存')
            //保存和新增修改
            if(this.checkmodify()!=false){
                this.modifyUser();
            }
            
        },
        init: function () {
            // loading(true);
            this.getUserInfo();
        },
        //个人信息查询
        getUserInfo() {
            this.userName = nativeJSBridge.getNativeValue("userName");
            getUserInfoAjax({loginName: this.userName}).then(res => {
                this.userName =res[0].ry0103;
                this.loginName=res[0].ry0102;
                this.userPosition=res[0].userPosition;
                this.telephone=res[0]. telephone;
                this.email=res[0].Email;
                this.address=res[0].ContactAddress;
                nativeJSBridge.hideNativeLoading();
            })
        },
        //账号管理modifyUserInfoAjax
        modifyUser() {
            modifyUserInfoAjax({
                email: this.email,
                address: this.address,
                userPosition: this.userPosition,
                telephone: this.telephone,
                userLoginName:this.loginName
            }).then(res => {
                if (res.success) {
                    this.$dialog.alert({
                        message: res.info
                    }).then(() => {
                        return;
                    });
                } else {
                    Toast.fail("保存失败请稍后再试")
                    return;
                }
            })
        },
        //格式校验
        checkmodify(){
            //邮箱
            const regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/; 
            if(!regEmail.test(this.email) && this.email!=''){ 
                this.$dialog.alert({
                    message: '请输入合法的邮箱!'
                })
                return false;
            }
            //手机号
            const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/; 
            if (!regMobile.test(this.telephone) && this.telephone!='') { 
                this.$dialog.alert({
                    message: '手机号码格式不正确!'
                })
                return false;
            }

        }
    }

}
